/**
 * O tema Shine pede a secção `cart-drawer` ao atualizar o carrinho.
 * O id real vem do grupo aside (`data-cdj-section`). A resposta volta com a chave antiga.
 */
(() => {
  if (window.__cartDrawerJuliageFetch) return;
  window.__cartDrawerJuliageFetch = true;

  const source = 'cart-drawer';
  const originalFetch = window.fetch.bind(window);

  const sectionId = () => {
    const drawer = document.getElementById('shtCartDrawer');
    return drawer?.getAttribute('data-cdj-section') || 'cart-drawer-juliage';
  };

  const rewrite = (value) => {
    const target = sectionId();
    const sectionPattern = new RegExp(`(^|["',=])${source}(?!-)(?=["',&,]|$)`, 'g');
    return value.replace(sectionPattern, `$1${target}`);
  };

  const aliasSection = (data) => {
    const target = sectionId();

    if (!data || typeof data !== 'object') return data;

    if (data.sections && data.sections[target] && !data.sections[source]) {
      data.sections[source] = data.sections[target];
    }

    if (data[target] && !data[source]) {
      data[source] = data[target];
    }

    return data;
  };

  window.fetch = async (input, init) => {
    let url = input;
    let nextInit = init;
    let touched = false;

    if (typeof input === 'string' && input.includes(source)) {
      const nextUrl = rewrite(input);
      touched = nextUrl !== input;
      url = nextUrl;
    }

    if (init?.body instanceof FormData) {
      const nextBody = new FormData();
      let changed = false;

      for (const [key, value] of init.body.entries()) {
        if (typeof value === 'string' && value.includes(source)) {
          const rewritten = rewrite(value);

          if (rewritten !== value) changed = true;

          nextBody.append(key, rewritten);
        } else {
          nextBody.append(key, value);
        }
      }

      if (changed) {
        nextInit = { ...init, body: nextBody };
        touched = true;
      }
    } else if (init && typeof init.body === 'string' && init.body.includes(source)) {
      const body = rewrite(init.body);

      if (body !== init.body) {
        nextInit = { ...init, body };
        touched = true;
      }
    }

    const response = await originalFetch(url, nextInit);

    if (!touched) return response;

    const copy = response.clone();

    try {
      const data = aliasSection(await copy.json());
      const headers = new Headers(response.headers);

      return new Response(JSON.stringify(data), {
        status: response.status,
        statusText: response.statusText,
        headers
      });
    } catch {
      return response;
    }
  };

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateHeaderCount = (count) => {
    if (count === null || count === '') return;

    for (const node of document.querySelectorAll('.cart-count-number')) {
      node.textContent = count;
    }

    const empty = count === '0';

    for (const bubble of document.querySelectorAll('.header__cart-count')) {
      bubble.classList.toggle('opacity-0', empty);
      bubble.classList.toggle('hidden-xs', empty);
    }
  };

  const replaceDrawer = (html) => {
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('.js-cart-drawer-wrapper');
    const current = document.querySelector('#cartDrawer .js-cart-drawer-wrapper');

    if (!next || !current) return;

    current.replaceWith(next);

    const host = document.getElementById('shtCartDrawer');

    if (host) host.drawerWrapperElement = next;

    updateHeaderCount(next.getAttribute('data-cart-count'));
  };

  let discountRequest = null;

  const applyGiftDiscount = async (code) => {
    const normalized = code.trim();

    if (!normalized || !window.routes?.cart_update_url) return null;

    if (discountRequest) return discountRequest;

    discountRequest = (async () => {
      const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' }
      });
      const cart = await cartResponse.json();
      const codes = (cart.discount_codes || []).map((entry) => entry.code).filter(Boolean);
      const present = codes.some((entry) => entry.toLowerCase() === normalized.toLowerCase());

      if (!present) codes.push(normalized);

      const updateResponse = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          discount: codes.join(','),
          attributes: { ...(cart.attributes || {}), _brinde_code: normalized },
          sections: sectionId(),
          sections_url: window.location.pathname
        })
      });

      if (!updateResponse.ok) return null;

      return updateResponse.json();
    })();

    try {
      return await discountRequest;
    } finally {
      discountRequest = null;
    }
  };

  const addVariant = async (button) => {
    const variantId = button.getAttribute('data-variant-id');

    if (!variantId || button.disabled) return;

    button.disabled = true;

    try {
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      body.append('sections', sectionId());
      body.append('sections_url', window.location.pathname);

      const isGift = button.getAttribute('data-cdj-gift') === 'true';

      if (isGift) body.append('properties[_brinde]', 'true');

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body
      });
      const data = await response.json();
      let html = data.sections?.[sectionId()];

      if (response.ok && isGift) {
        const code = button.getAttribute('data-cdj-discount') || '';
        const updated = await applyGiftDiscount(code);
        const giftLine = (updated?.items || []).find((item) => item.properties?._brinde);
        const free = Boolean(giftLine) && giftLine.final_line_price === 0;

        if (!free) {
          await fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: data.key,
              quantity: 0
            })
          });

          const remaining = (updated?.discount_codes || [])
            .map((entry) => entry.code)
            .filter((entry) => entry && entry.toLowerCase() !== code.trim().toLowerCase());
          const removed = await fetch(window.routes.cart_update_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              discount: remaining.join(','),
              attributes: { _brinde_code: '' },
              sections: sectionId(),
              sections_url: window.location.pathname
            })
          });
          const removedData = await removed.json();

          html = removedData.sections?.[sectionId()] || html;
          replaceDrawer(html);

          const errors = document.querySelector('#cart-drawer__errors');
          const message = document.querySelector('.js-error-discount')?.textContent?.trim();

          if (errors && message) errors.textContent = message;

          button.disabled = false;
          return;
        }

        html = updated?.sections?.[sectionId()] || html;
      }

      if (!response.ok || !html) {
        button.disabled = false;
        return;
      }

      replaceDrawer(html);
    } catch {
      button.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-cdj-add]');

    if (addButton) {
      event.preventDefault();
      addVariant(addButton);
      return;
    }

    const arrow = event.target.closest('[data-cdj-prev], [data-cdj-next]');

    if (!arrow) return;

    const track = arrow.closest('[data-cdj-recs]')?.querySelector('[data-cdj-track]');
    const card = track?.querySelector('.cdj-recs__card');

    if (!track || !card) return;

    const direction = arrow.hasAttribute('data-cdj-prev') ? -1 : 1;

    track.scrollBy({
      left: card.offsetWidth * direction,
      behavior: motion.matches ? 'auto' : 'smooth'
    });
  });

  const drawerInSection = (target) => Boolean(target?.querySelector?.('#shtCartDrawer') || target?.closest?.('#shtCartDrawer'));

  const openEditorDrawer = () => {
    const drawer = window.shtCartDrawer;

    if (typeof drawer?.openDrawer === 'function') {
      drawer.openDrawer();
      return;
    }

    document.addEventListener('DOMContentLoaded', () => {
      window.shtCartDrawer?.openDrawer?.();
    }, { once: true });
  };

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:select', (event) => {
      if (!drawerInSection(event.target)) return;
      openEditorDrawer();
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (!drawerInSection(event.target)) return;
      openEditorDrawer();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (!drawerInSection(event.target)) return;
      window.shtCartDrawer?.closeDrawer?.();
    });
  }

  const syncGiftDiscount = async () => {
    const code = document.getElementById('shtCartDrawer')?.getAttribute('data-cdj-apply-discount');

    if (!code) return;

    const guard = `cdj-gift-discount:${code}`;

    if (sessionStorage.getItem(guard)) return;

    const updated = await applyGiftDiscount(code);
    const html = updated?.sections?.[sectionId()];

    if (updated) sessionStorage.setItem(guard, '1');
    if (html) replaceDrawer(html);
  };

  syncGiftDiscount();
})();
